import React, {
    useContext,
    useState,
    useEffect,
} from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';

import { refetchBasketData, NotificationContext, handleError } from '../router'

import * as OPTIONS from "../option-fields";
import * as QUERIES from "../query-functions";

import LoadingIndicator from '../components/loading-indicator';

const fundId = OPTIONS.additionalUpsell.fund?.innerHTML;
const amounts = OPTIONS.additionalUpsell.amounts ? JSON.parse(OPTIONS.additionalUpsell.amounts)?.sort((a, b) => a - b) : null;

export default function AdditionalDonation(props) {

    const {notification, setNotification} = useContext(NotificationContext);
    const [selectedAmount, setSelectedAmount] = useState(null);

    const addDonation = useMutation({
        mutationFn: () => QUERIES.addDonation([{Amount: selectedAmount, FundId: fundId}]),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            refetchBasketData();
        },
    });

    return (
        <div className='booking-pathway__additional-donation'>
            <h1 className='booking-pathway__header'>{OPTIONS.additionalUpsell.title?.innerHTML ? OPTIONS.additionalUpsell.title.innerHTML : "Support us"}</h1>

            <article className='extras-instance extras-instance__additional-donation stack'>
                {OPTIONS.additionalUpsell.image?.innerHTML &&
                    <div className='extras-instance__image' dangerouslySetInnerHTML={{__html: OPTIONS.additionalUpsell.image.innerHTML}}></div>
                }

                {OPTIONS.additionalUpsell.introduction?.innerHTML &&
                    <div className='extras-instance__summary' dangerouslySetInnerHTML={{__html: OPTIONS.additionalUpsell.introduction.innerHTML}}></div>
                }
    
                <div className='extras-instance__footer'>
                    <p className='sr-text'>Select and amount to donate</p>
                    <div className='extras-instance__buttons'>
                        {amounts?.map((amount) => (
                            <button key={amount} type="button" className={`btn booking-pathway__additional-donation--amount ${amount == selectedAmount ? 'active' : ''}`} onClick={() => setSelectedAmount(amount)}>£{amount}</button>
                        ))}
                    </div>
                    {selectedAmount ?                        
                        <button type="button" 
                                disabled={addDonation.isPending}
                                className='booking-pathway__additional-donation--button btn btn--primary' 
                                onClick={() => addDonation.mutateAsync()}>
                            Add donation to basket
                            {addDonation.isPending &&
                                <LoadingIndicator />
                            }
                        </button>
                    :
                        <p className='booking-pathway__additional-donation--button btn btn--primary disabled'>Add donation to basket</p>
                    }
                </div>
            </article>
        </div>

    );
}